/**
 * FDM Page Utility Functions
 * Shared helper functions for FDM tab components
 */

export const getSeverityColor = (severity) => {
  const colors = {
    level_1: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    level_2: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    level_3: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    level_4: 'bg-red-500/20 text-red-400 border-red-500/30',
    level_5: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
  };
  return colors[severity] || 'bg-slate-500/20 text-slate-400';
};

export const getSeverityLabel = (severity) => {
  const labels = {
    level_1: 'Level 1 - Minor',
    level_2: 'Level 2 - Moderate',
    level_3: 'Level 3 - Serious',
    level_4: 'Level 4 - Severe',
    level_5: 'Level 5 - Critical',
  };
  return labels[severity] || severity;
};

export const formatCategory = (category) => {
  return category?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Unknown';
};

export const getRiskLevelColor = (level) => {
  const colors = {
    low: 'bg-green-500/20 text-green-400 border-green-500/30',
    moderate: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    high: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    critical: 'bg-red-500/20 text-red-400 border-red-500/30',
  };
  return colors[level] || 'bg-slate-500/20 text-slate-400';
};

export const getConfidenceColor = (confidence) => {
  const colors = {
    very_high: 'text-green-400',
    high: 'text-blue-400',
    medium: 'text-yellow-400',
    low: 'text-slate-400',
  };
  return colors[confidence] || 'text-slate-400';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatShortDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
};
